import React, { useEffect, useState } from "react"
import { KLogo, KSpan, KTitleSpan } from "kahuna-base-react-components"
import { lang } from "../constants/languages"

const APP_STORE_URL = "https://apps.apple.com/tr/app/kahuna-music/id6751541624"
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.kahuna.music"

type Platform = "ios" | "android" | "unknown"

const detectPlatform = (): Platform => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || ""

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return "ios"
  }

  if (/android/i.test(userAgent)) {
    return "android"
  }

  return "unknown"
}

const MobileAppRedirect = () => {
  const [platform, setPlatform] = useState<Platform>("unknown")
  const [countdown, setCountdown] = useState(3)

  useEffect(() => {
    const detectedPlatform = detectPlatform()
    setPlatform(detectedPlatform)

    if (detectedPlatform !== "unknown") {
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval)
            const url = detectedPlatform === "ios" ? APP_STORE_URL : PLAY_STORE_URL
            window.location.href = url
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [])

  const handleStoreClick = (store: "ios" | "android") => {
    const url = store === "ios" ? APP_STORE_URL : PLAY_STORE_URL
    window.location.href = url
  }

  const getRedirectingText = () => {
    return lang.mobile_app_redirect.redirecting.replace("{seconds}", countdown.toString())
  }

  return (
    <div
      style={{
        background: "white",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 32,
          maxWidth: 380,
          width: "100%"
        }}
      >
        <div
          style={{
            border: "1px solid #eeeeee",
            padding: "26px 32px",
            borderRadius: 20,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
          }}
        >
          <img src={"/Logo.png"} width={44} />
        </div>

        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
          <KTitleSpan text={lang.mobile_app_redirect.title} fontSize={24} lineHeight="28px" fontWeight={600} />
          <KSpan text={lang.mobile_app_redirect.description} fontSize={14} color="#666" />
        </div>

        {platform !== "unknown" && countdown > 0 && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              padding: "10px 20px",
              background: "#F5F5F5",
              borderRadius: 100
            }}
          >
            <div
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: "#111",
                animation: "pulse 1s infinite"
              }}
            />
            <KSpan text={getRedirectingText()} fontSize={13} color="#111" />
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: 12, width: "100%" }}>
          <button
            onClick={() => handleStoreClick("ios")}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 12,
              padding: "16px 24px",
              background: "black",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              cursor: "pointer",
              fontFamily: "inherit"
            }}
          >
            <svg width="34" height="40" viewBox="0 0 22 26" fill="none">
              <path
                d="M18 13.5c0-3.1 2.5-4.6 2.6-4.7-1.4-2.1-3.6-2.3-4.4-2.4-1.9-.2-3.6 1.1-4.6 1.1s-2.4-1.1-3.9-1.1c-2 0-3.8 1.2-4.9 3-2.1 3.6-.5 9 1.5 11.9 1 1.5 2.2 3.1 3.7 3 1.5-.1 2.1-1 3.9-1s2.3 1 3.9.9c1.6 0 2.6-1.5 3.6-2.9 1.1-1.7 1.6-3.3 1.6-3.4 0 0-3.1-1.1-3.1-4.4zM15 4.4c.8-1 1.4-2.4 1.2-3.8-1.2.1-2.6.8-3.5 1.8-.8.9-1.4 2.3-1.3 3.7 1.4.1 2.8-.7 3.6-1.7z"
                fill="currentColor"
              />
            </svg>
            <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
              <KSpan text={lang.mobile_app_redirect.download_on} color="white" />
              <KSpan text={lang.mobile_app_redirect.app_store} fontSize={22} color="white" fontWeight={600} />
            </div>
          </button>

          <button
            onClick={() => handleStoreClick("android")}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 12,
              padding: "16px 24px",
              background: "black",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              cursor: "pointer",
              fontFamily: "inherit"
            }}
          >
            <svg width="28" height="30" viewBox="0 0 22 24" fill="none">
              <path
                d="M1.57 1.32c-.36.38-.57.96-.57 1.68v18c0 .72.21 1.3.57 1.68l.09.08L12.5 12l-.08-.08L1.66 1.24l-.09.08z"
                fill="#4285F4"
              />
              <path d="M16.14 15.64L12.5 12l3.64-3.64 4.12 2.34c1.18.67 1.18 1.76 0 2.43l-4.12 2.51z" fill="#FBBC04" />
              <path d="M16.14 15.64l-3.64-3.64-10.93 10.68c.39.41.98.43 1.64.06l12.93-7.1z" fill="#EA4335" />
              <path d="M16.14 15.64l-3.64-3.64-10.93 10.68c.39.41.98.43 1.64.06l12.93-7.1z" fill="#EA4335" />
              <path d="M16.14 8.36L3.21 1.26c-.66-.37-1.25-.35-1.64.06L12.5 12l3.64-3.64z" fill="#34A853" />
            </svg>
            <div style={{ textAlign: "left", display: "flex", flexDirection: "column" }}>
              <KSpan text={lang.mobile_app_redirect.get_it_on} color="white" />
              <KSpan text={lang.mobile_app_redirect.google_play} fontSize={22} color="white" fontWeight={600} />
            </div>
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.5; transform: scale(1.2); }
          }
        `}
      </style>
    </div>
  )
}

export default MobileAppRedirect
